export interface Resource {
  currency: string;
  amount: number;
}

export interface SlotFreeSpins {
  slotId: string;
  count: number;
  bet: number;
}

export interface CityVoucher {
  cityId: string;
  amount: number;
}

export interface RewardBundle {
  resources: Resource[];
  cityVouchers: CityVoucher[];
  slotFreeSpins: SlotFreeSpins | null;
}

export type SlotFreeSpinsOfferLevel = "Low" | "Middle" | "High";

export interface SlotFreeSpinsOffer {
  level: SlotFreeSpinsOfferLevel;
  availableWin: number;
}

export interface ShopItem {
  price: number;
  id: string;
  shopId: string;
  isOfferItem: boolean;
  title: string;
  group: string;
  image: string;
  discount: number;
  rewardBundle: RewardBundle;
  vipRewardBundle: RewardBundle;
  purchaseBonusPercent: number | null;
  labelType: string | null;
  isVisible: boolean;
}

export interface OfferItem extends ShopItem {
  offerName: string;
  expirationDate: number;
  claimParameter: string | null;
  groupId: string | null;
  slotFreeSpinsOffer: SlotFreeSpinsOffer | null;
}

export interface VipStatusItem extends ShopItem {
  vipDurationDays: number;
}

export interface VipStatus {
  activeBeforeTimestamp: number | null;
  isActive: boolean;
  purchaseBonusPercent: number;
}

export interface ShopItems {
  chips: ShopItem[];
  tickets: ShopItem[];
  offers: OfferItem[];
  vipStatusItems: VipStatusItem[];
  vipStatus: VipStatus;
}

export function isOfferItem(item: ShopItem): item is OfferItem {
  return "offerName" in item;
}

export function isVipItem(item: ShopItem): item is VipStatusItem {
  return "vipDurationDays" in item;
}
